<template>
<div>
    <router-view/>
</div>
</template>

<script>
export default {
  name: 'ControlDrugRegisterAdmin',
  data () {
    return {
    }
  },
}
</script>

<style lang="scss">
</style>